export const s3FormSchema = [
  {
    name: 'service',
    title: 'Serviço',
    type: 'select',
    lgWidth: 12,
    description: 'Selecione o serviço de nuvem compatível.',
    options: [
      { value: 'aws', label: 'AWS' },
      { value: 'backblaze', label: 'Backblaze B2 - S3 Compatible' },
      { value: 'oracle', label: 'Oracle Cloud Object Storage' }
    ],
    required: true
  },
  {
    name: 'region',
    title: 'Região',
    description: 'Onde os seus dados estão fisicamente armazenados.',
    type: 'select',
    lgWidth: 4,
    options: [
      { value: 'ca-east', label: 'CA East' },
      { value: 'eu-central', label: 'EU Central' },
      { value: 'us-east', label: 'US East (us-east-005)' },
      { value: 'us-west', label: 'US West' }
    ],
    required: false
  },
  {
    name: 'accessKeyId',
    title: 'Access Key / Key ID',
    description: 'Chave gerada no console da Backblaze.',
    type: 'text',
    lgWidth: 4,
    required: true
  },
  {
    name: 'secretAccessKey',
    title: 'Secret Key / Application Key',
    description: 'Chave secreta gerada no console da Backblaze.',
    type: 'text',
    lgWidth: 4,
    required: true
  },
  {
    name: 'bucket',
    title: 'Nome do Bucket',
    description: 'Informe exatamente o nome do bucket criado na Backblaze.',
    type: 'text',
    lgWidth: 6,
    required: true
  },
  {
    name: 'endpoint',
    title: 'S3 Endpoint',
    description:
      'Use o endpoint informado no painel do bucket. Geralmente segue o formato `https://s3.<region>.backblazeb2.com`.',
    type: 'text',
    lgWidth: 6,
    required: false
  },
  {
    name: 'prefix',
    title: 'Prefixo / Pasta',
    description: 'Organize os arquivos em um subdiretório específico.',
    type: 'text',
    lgWidth: 6,
    required: false
  }
]
